import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
// @ts-ignore or declare module 'pdf-lib'
import { UnderlineRowDiv } from "../../../../components/misc/misc.styled";
import { Spacer } from "../../../../components";
import { CustomAlert } from "../../../../components/dialogue/Dialogue";
import { RowDiv, ColDiv } from "../../../../components/misc/misc.styled";
import { FC, useState, useEffect, useRef } from "react";
import {
  CreateProjectFileInput,
  FileType,
  Project,
} from "../../../../redux/types";
import {
  Grid,
  IconButton,
  Accordion,
  AccordionSummary,
  Box,
  AccordionDetails,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { PDFDocument } from "pdf-lib";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useParams } from "react-router-dom";
import { useFetchInvoices, usePreviewInvoice } from "../../../../apolloClient/hooks/general/fetchHook";
import { useMutation } from "@apollo/client";
import { CREATE_INVOICE, UPDATE_INVOICE, UPLOAD_MERGED_INVOICE } from "../../../../apolloClient/operation/mutations";
import { SEND_INVOICE_EMAIL } from "../../../../apolloClient/operation/mutations/mutation";
import {
  CreateInvoiceInput,
  CreateUploadFileInput,
  InvoiceType,
  UpdateInvoiceInput,
} from "../../../../types/graphQlQuery.interface";
import {
  useCreateProjectFile,
  useCreateUploadUrl,
} from "../../../../apolloClient/hooks/general/createHook";
import { toast } from "react-toastify";
import { uploadImage } from "../../../../redux/api/common";
import { logEvent, PROJECT_EVENTS } from "../../../../utils/amplitude";
import { CustomerProjectDetails } from "../../../../redux/types/projectDetails";

interface CertificateProps {
  onFetchProject: Function;
  project?: CustomerProjectDetails;
  permissions?: boolean;
}

export const Invoice: FC<CertificateProps> = ({ project, onFetchProject, permissions }) => {
    // State for Send Email Dialog
    const [sendEmailOpen, setSendEmailOpen] = useState(false);
    const [emailInput, setEmailInput] = useState("");
    const [messageInput, setMessageInput] = useState("Your invoice is ready!");
    const [sending, setSending] = useState(false);

    // Helper to check if invoice file exists
    const hasInvoiceFile = () => {
      const files = project?.documents || [];
      return files.some(f => (f.type === FileType.MERGED_INVOICE || f.type === FileType.INVOICE) && f.url);
    };

    // Open dialog only if invoice file exists
    const handleOpenSendEmail = () => {
      if (!hasInvoiceFile()) {
        toast("Please generate the invoice first", {
          type: "info",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
      // Autofill email if available
      const customerEmail = project?.customerDetails?.email || "";
      setEmailInput(customerEmail);
      setSendEmailOpen(true);
    };

    // Send email mutation handler
    const handleSendEmail = async () => {
      if (!emailInput) {
        toast("Please enter recipient email", { type: "error", position: "top-left", className: "toast-message" });
        return;
      }
      setSending(true);
      try {
        await sendInvoiceEmail({ variables: { input: { email: emailInput, projId: Number(id), message: messageInput } } });
        toast("Invoice email sent successfully", { type: "success", position: "top-left", className: "toast-message" });
        
        // Track invoice email sent
        logEvent(PROJECT_EVENTS.INVOICE_EMAIL_SENT, {
          project_id: Number(id),
          recipient_email: emailInput,
          timestamp: new Date().toISOString(),
        });
        
        setSendEmailOpen(false);
        setEmailInput("");
        setMessageInput("");
      } catch (err) {
        toast("Failed to send invoice email", { type: "error", position: "top-left", className: "toast-message" });
      } finally {
        setSending(false);
      }
    };
  // Send Invoice Email mutation
  const [sendInvoiceEmail] = useMutation(SEND_INVOICE_EMAIL);
  // Handler for previewing invoice (merged or single)

  const handlePreviewInvoice = () => {
    // Only check documents array for invoice files
    const files = project?.documents || [];
    if (!files || !Array.isArray(files) || files.length === 0) {
      toast("Please generate the invoice first", {
        type: "info",
        position: "top-left",
        className: "toast-message",
      });
      return;
    }
    // Try to find merged invoice first
    const merged = files.find(f => f.type === FileType.MERGED_INVOICE && f.url);
    if (merged) {
      window.open(merged.url, "_blank");
      return;
    }
    // Try to find invoice
    const invoice = files.find(f => f.type === FileType.INVOICE && f.url);
    if (invoice) {
      window.open(invoice.url, "_blank");
      return;
    }
    // If neither found
    toast("Please generate the invoice first", {
      type: "info",
      position: "top-left",
      className: "toast-message",
    });
  };
  const fileRef = useRef<HTMLInputElement>(null);
  let { id } = useParams();
  const [invoices, setInvoices] = useState<any[]>([]);
  const [addOns, setAddOns] = useState<any[]>([]);
  const [uploadUrl, setUploadUrl] = useState("");
  const [fileUrl, setFileUrl] = useState<string>("");
  const [isUploading, setIsUploading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false); // Custom loading state for preview+file
  const [selectedBrand, setSelectedBrand] = useState<string>("glas");
    // State for editing line items
    const [editingItem, setEditingItem] = useState<{ invoiceIdx: number; itemIdx: number } | null>(null);
    const [editItemData, setEditItemData] = useState<any>({});

  const {
    invoiceDetails: invoiceData,
    loading: invoiceLoading,
    error: invoiceError,
    refetch: refetchInvoices,
  } = useFetchInvoices({
    projectId: Number(id),
  });

  const { generateInvoice, loading: previewLoading, previewUrl } =
    usePreviewInvoice();

  useEffect(() => {
    if (invoiceData) {
      setInvoices(invoiceData.invoices);
      setAddOns(
        invoiceData.addOns?.length > 0
          ? invoiceData.addOns
          : [{ name: "Project Facilitation", Items: [], total: {} }] // Default add-on
      );
    }
  }, [invoiceData]);

  const [createInvoice] = useMutation<
    {
      createInvoice: boolean;
    },
    { input: CreateInvoiceInput }
  >(CREATE_INVOICE);

  const [updateInvoice] = useMutation<
    {
      updateInvoice: boolean;
    },
    { input: UpdateInvoiceInput }
  >(UPDATE_INVOICE);

  const [uploadMergedInvoice] = useMutation(UPLOAD_MERGED_INVOICE);

  const [newInvoice, setNewInvoice] = useState<CreateInvoiceInput>({
    projectId: Number(id),
    productId: 0,
    invoiceType: "Material",
    name: "",
    description: "",
    amount: 0,
    date: "",
    identifier: "",
    url: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewInvoice({
      ...newInvoice,
      [name]: name === "amount" ? parseFloat(value) : value,
    });
  };

  const handleAddInvoice = (productId: number, invoiceType: InvoiceType) => {
    createInvoice({
      variables: {
        input: { ...newInvoice, productId, invoiceType, url: fileUrl },
      },
    }).then(() => {
      refetchInvoices();
      toast("Invoice added successfully", {
        type: "success",
        position: "top-left",
        className: "toast-message",
      });
      
      // Track invoice creation
      logEvent(PROJECT_EVENTS.INVOICE_CREATED, { 
        project_id: Number(id), 
        invoice_amount: newInvoice.amount || 0 
      });
      setNewInvoice({
        projectId: Number(id),
        productId: 0,
        invoiceType: "Material",
        name: "",
        description: "",
        amount: 0,
        date: "",
        identifier: "",
        url: "",
      });
      setFileUrl(""); 
      if (fileRef.current) {
        fileRef.current.value = ""; 
      }
    });
  };

  const { createUploadUrl } = useCreateUploadUrl();
  const { createProjectFile } = useCreateProjectFile();

  const getUplaodUrl = async () => {
    setIsUploading(true);
    try {
      const file = fileRef.current?.files[0];

      const input: CreateUploadFileInput = {
        contentType: file?.type,
      };

      const success = await createUploadUrl(input);
      if (success) {
        setUploadUrl(success.url);
        setFileUrl(success.fileName);
        await onUpload(success.url, success.fileName);
        return;
      } else {
        throw new Error("Failed to create Upload url.");
      }
    } catch (error) {
      console.error("Error getting upload URL: ", error);
      toast("Error getting upload URL", {
        type: "error",
        position: "top-left",
        className: "toast-message",
      });
    }
  };

  const handleCreateProjectFile = async (fileName: string, type: FileType = FileType.INVOICE_DOC) => {
    const input: CreateProjectFileInput = {
      projectId: Number(id),
      url: fileName,
      type,
    };

    try {
      const success = await createProjectFile(input);
      if (success) {
        setUploadUrl("");
        // setFileUrl("");
        // if (fileRef.current) {
        //   fileRef.current.value = "";
        // }
        onFetchProject();
        toast("Document uploaded successfully", {
          type: "info",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    } catch (error) {
      throw error;
    } finally {
      setIsUploading(false);
    }
  };

  const onUpload = async (url: string, fileName: string) => {
    const file = fileRef.current?.files[0];
    if (!file) {
      toast("An image have not been selected", {
        type: "error",
        position: "top-left",
        className: "toast-message",
      });
      return;
    }

    try {
      const result = await uploadImage(url, file);
      if (result.success) {
        await handleCreateProjectFile(fileName);
      } else {
        throw new Error("Upload failed");
      }
    } catch (error) {
      console.error("Error uploading image ", error);
      toast("Error uploading document", {
        type: "error",
        position: "top-left",
        className: "toast-message",
      });
    }
  };

  const handleGenerateFinalInvoice = async () => {
    setIsPreviewLoading(true);
    
    // Track invoice generation
    logEvent(PROJECT_EVENTS.INVOICE_CREATED, {
      project_id: Number(id),
      timestamp: new Date().toISOString(),
    });
    
    try {
      const { data } = await generateInvoice({ 
        variables: { 
          projectId: Number(id),
          source: selectedBrand
        } 
      });
      if (data?.previewInvoice?.url) {
        // If there are additional URLs, merge all PDFs client-side and open merged PDF
        const mainUrl = data.previewInvoice.url;
        const additional: string[] = data.previewInvoice.additionalUrls || [];
        const allUrls = [mainUrl, ...additional].filter(Boolean);

        if (allUrls.length > 1) {
          try {
            const mergedBytes = await mergeAndOpenPdfs(allUrls);
            // Upload merged PDF to server
            const input = { contentType: "application/pdf" };
            const uploadResult = await createUploadUrl(input);
            if (uploadResult && uploadResult.url) {
              // Use uploadImage helper for consistency
              const pdfFile = new File([new Uint8Array(mergedBytes)], uploadResult.fileName || `merged-invoice.pdf`, { type: "application/pdf" });
              const result = await uploadImage(uploadResult.url, pdfFile);
              if (result.success) {
                console.log("Merged PDF uploaded successfully to:", uploadResult.fileName);
                // Register the file in backend using UploadMergedInvoice mutation
                await uploadMergedInvoice({ variables: { projId: Number(id), url: uploadResult.fileName } });
                toast("Invoice generated successfully", {
                  type: "success",
                  position: "top-left",
                  className: "toast-message",
                });
                // Refresh project details after upload
                onFetchProject();
                // Open the merged PDF in a new tab
                if (uploadResult.fileName) {
                  window.open(uploadResult.fileName, "_blank");
                }
              } else {
                console.error("Failed to upload merged PDF");
              }
            } else {
              console.error("Failed to get upload URL");
            }
          } catch (mergeErr) {
            console.error("Error merging PDFs:", mergeErr);
            // fallback to opening main url if merge fails
            window.open(mainUrl, "_blank");
            // Still refresh project details
            onFetchProject();
          }
        } else {
          window.open(mainUrl, "_blank");
          // Refresh project details after single invoice
          onFetchProject();
        }
      } else {
        toast("Failed to generate final invoice", {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
      }
    } catch (error) {
      console.error("Error generating final invoice: ", error);
      toast("Error generating final invoice", {
        type: "error",
        position: "top-left",
        className: "toast-message",
      });
    } finally {
      setIsPreviewLoading(false);
    }
  };

  // Merge multiple PDF URLs into a single PDF and open in new tab.
  // Uses `pdf-lib` to concatenate pages.
  const mergeAndOpenPdfs = async (urls: string[]) => {
    if (!urls || urls.length === 0) return;
    try {
      const mergedPdf = await PDFDocument.create();

      for (const url of urls) {
        const res = await fetch(url);
        if (!res.ok) throw new Error(`Failed to fetch PDF: ${url} (status ${res.status})`);
        const arrayBuffer = await res.arrayBuffer();
        const pdf = await PDFDocument.load(arrayBuffer);
        const copied = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
        copied.forEach((page) => mergedPdf.addPage(page));
      }

      const mergedBytes = await mergedPdf.save();
      return mergedBytes;
    } catch (err) {
      throw err;
    }
  };

  const InvoiceDetails = () => {
    return (
      <>
        <Box sx={{ mb: 3 }}>
          <h1 className="text-lg" style={{ marginBottom: "16px" }}>Invoice</h1>
          <Box
            sx={{
              backgroundColor: "#4285F4",
              color: "white",
              padding: { xs: 2, sm: 2.5 },
              borderRadius: "8px",
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(3, 1fr)" },
              gap: { xs: 1.5, sm: 2 },
            }}
          >
            <Box>
              <Box sx={{ fontSize: 12, opacity: 0.9, mb: 0.5 }}>Project Subtotal</Box>
              <Box sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 600 }}>
                ${invoiceData?.total.projectSubTotal || 0}
              </Box>
            </Box>
            <Box>
              <Box sx={{ fontSize: 12, opacity: 0.9, mb: 0.5 }}>Glas Fee</Box>
              <Box sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 600 }}>
                ${invoiceData?.total.glasFee || 0}
              </Box>
            </Box>
            <Box>
              <Box sx={{ fontSize: 12, opacity: 0.9, mb: 0.5 }}>Project Total</Box>
              <Box sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 600 }}>
                ${invoiceData?.total.projectTotal || 0}
              </Box>
            </Box>
            <Box>
              <Box sx={{ fontSize: 12, opacity: 0.9, mb: 0.5 }}>Prior Payments</Box>
              <Box sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 600 }}>
                ${invoiceData?.total.priorPayments || 0}
              </Box>
            </Box>
            <Box>
              <Box sx={{ fontSize: 12, opacity: 0.9, mb: 0.5 }}>
                {invoiceData?.total.paymentDue > 0 ? "Payment Due" : "Refund Due"}
              </Box>
              <Box sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 600 }}>
                ${Math.abs(invoiceData?.total.paymentDue || 0)}
              </Box>
            </Box>
          </Box>
        </Box>
        <Spacer size={1} direction="col" />
        {invoices?.map((invoice, index) => (
          <Accordion
            key={index}
            sx={{
              border: "1px solid #e5e7eb",
              borderRadius: "8px !important",
              boxShadow: "none",
              mb: 1.5,
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                "&:hover": { backgroundColor: "#f9fafb" },
              }}
            >
              <Box sx={{ fontSize: { xs: 15, sm: 17 }, fontWeight: 600, color: "#1f2937" }}>
                {invoice.name.replace("-", " - ")}
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ px: { xs: 1, sm: 2 } }}>
              {/* Desktop Table View */}
              <Box sx={{ display: { xs: "none", md: "block" }, width: "100%", overflowX: "auto" }}>
                <table style={{ width: "100%", minWidth: "600px" }}>
                  <thead>
                    <tr
                      className="text-left"
                      style={{ borderBottom: "1px solid black" }}
                    >
                      <th
                        className="font-semibold pb-2"
                        style={{ width: "20%" }}
                      >
                        Contractor/ Supplier
                      </th>
                      <th
                        className="font-semibold pb-2"
                        style={{ width: "20%" }}
                      >
                        Description
                      </th>
                      <th
                        className="font-semibold pb-2"
                        style={{ width: "20%" }}
                      >
                        Identifier
                      </th>
                      <th
                        className="font-semibold pb-2"
                        style={{ width: "20%" }}
                      >
                        Date
                      </th>
                      <th
                        className="font-semibold pb-2"
                        style={{ width: "20%" }}
                      >
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice?.Items?.map((item, idx) => (
                        <tr key={idx}>
                          {editingItem && editingItem.invoiceIdx === index && editingItem.itemIdx === idx ? (
                            <>
                              <td>
                                <TextField
                                  size="small"
                                  value={editItemData.name || ""}
                                  onChange={e => setEditItemData({ ...editItemData, name: e.target.value })}
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  value={editItemData.description || ""}
                                  onChange={e => setEditItemData({ ...editItemData, description: e.target.value })}
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  value={editItemData.identifier || ""}
                                  onChange={e => setEditItemData({ ...editItemData, identifier: e.target.value })}
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  type="date"
                                  value={editItemData.date}
                                  onChange={e => setEditItemData({ ...editItemData, date: e.target.value })}
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  type="number"
                                  value={editItemData.amount || 0}
                                  onChange={e => setEditItemData({ ...editItemData, amount: e.target.value })}
                                />
                              </td>
                              <td>
                                <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                  <IconButton onClick={() => item?.url.length > 0 && window.open(item?.url)}>
                                    <OpenInNewRoundedIcon />
                                  </IconButton>
                                  <IconButton color="primary" onClick={async () => {
                                    // Prepare input for updateInvoice mutation
                                    // Convert date from yyyy-mm-dd to mm/dd/yyyy
                                    let date = editItemData.date;
                                    if (date && date.includes('-')) {
                                      const [year, month, day] = date.split('-');
                                      date = `${day}/${month}/${year}`;
                                    }
                                    const input = {
                                      ...editItemData,
                                      invoiceId: editItemData.id,
                                      amount: Number(editItemData.amount),
                                      date,
                                    };
                                    delete input.id;
                                    await updateInvoice({ variables: { input } });
                                    setEditingItem(null);
                                    // Optionally refetch invoices to update UI
                                    if (refetchInvoices) refetchInvoices();
                                  }}>
                                    <span className="material-icons">check</span>
                                  </IconButton>
                                  <IconButton color="secondary" onClick={() => setEditingItem(null)}>
                                    <span className="material-icons">close</span>
                                  </IconButton>
                                </div>
                              </td>
                            </>
                          ) : (
                            <>
                              <td>{item.name}</td>
                              <td>{item.description}</td>
                              <td>{item.identifier}</td>
                              <td>{item.date}</td>
                              <td>${item.amount.toFixed(2)}</td>
                              <td>
                                <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                  <IconButton onClick={() => item?.url.length > 0 && window.open(item?.url)}>
                                    <OpenInNewRoundedIcon />
                                  </IconButton>
                                  {permissions && (
                                    <IconButton onClick={() => {
                                        setEditingItem({ invoiceIdx: index, itemIdx: idx });
                                        // Ensure date is in YYYY-MM-DD format for input type="date"
                                        let formattedDate = "";
                                        if (item.date) {
                                          const [month, day, year] = item.date.split("/");
                                          formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
                                        }
                                        setEditItemData({ ...item, date: formattedDate });
                                    }}>
                                      <span className="material-icons">edit</span>
                                    </IconButton>
                                  )}
                                </div>
                              </td>
                            </>
                          )}
                        </tr>
                    ))}
                  </tbody>
                </table>
              </Box>

              {/* Add New Invoice Item Inputs - Visible on all screens */}
              {permissions && (
                <>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(5, 1fr)" },
                      gap: 2,
                      width: "100%",
                      mb: 2,
                      mt: 3,
                    }}
                  >
                    <Box>
                      <Typography sx={{ mb: 0.75, fontSize: 14, fontWeight: 500, color: "#374151" }}>Contractor Name</Typography>
                      <input
                        type="text"
                        name="name"
                        value={newInvoice.name}
                        onChange={handleInputChange}
                        placeholder="Enter name"
                        style={{
                          padding: "12px 14px",
                          borderRadius: "6px",
                          border: "1px solid #d1d5db",
                          fontSize: "14px",
                          width: "100%",
                          backgroundColor: "#f9fafb",
                          color: "#374151",
                          boxSizing: "border-box",
                        }}
                      />
                    </Box>
                    <Box>
                      <Typography sx={{ mb: 0.75, fontSize: 14, fontWeight: 500, color: "#374151" }}>Description</Typography>
                      <input
                        type="text"
                        name="description"
                        value={newInvoice.description}
                        onChange={handleInputChange}
                        placeholder="Enter description"
                        style={{
                          padding: "12px 14px",
                          borderRadius: "6px",
                          border: "1px solid #d1d5db",
                          fontSize: "14px",
                          width: "100%",
                          backgroundColor: "#f9fafb",
                          color: "#374151",
                          boxSizing: "border-box",
                        }}
                      />
                    </Box>
                    <Box>
                      <Typography sx={{ mb: 0.75, fontSize: 14, fontWeight: 500, color: "#374151" }}>Identifier</Typography>
                      <input
                        type="text"
                        name="identifier"
                        value={newInvoice.identifier}
                        onChange={handleInputChange}
                        placeholder="Enter identifier"
                        style={{
                          padding: "12px 14px",
                          borderRadius: "6px",
                          border: "1px solid #d1d5db",
                          fontSize: "14px",
                          width: "100%",
                          backgroundColor: "#f9fafb",
                          color: "#374151",
                          boxSizing: "border-box",
                        }}
                      />
                    </Box>
                    <Box>
                      <Typography sx={{ mb: 0.75, fontSize: 14, fontWeight: 500, color: "#374151" }}>Date</Typography>
                      <input
                        type="date"
                        name="date"
                        value={newInvoice.date}
                        onChange={handleInputChange}
                        style={{
                          padding: "12px 14px",
                          borderRadius: "6px",
                          border: "1px solid #d1d5db",
                          fontSize: "14px",
                          width: "100%",
                          backgroundColor: "#f9fafb",
                          color: "#374151",
                          boxSizing: "border-box",
                        }}
                      />
                    </Box>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Box sx={{ flex: 1 }}>
                        <Typography sx={{ mb: 0.75, fontSize: 14, fontWeight: 500, color: "#374151" }}>Amount</Typography>
                        <input
                          type="number"
                          name="amount"
                          value={newInvoice.amount}
                          onChange={handleInputChange}
                          placeholder="0"
                          style={{
                            padding: "12px 14px",
                            borderRadius: "6px",
                            border: "1px solid #d1d5db",
                            fontSize: "14px",
                            width: "100%",
                            backgroundColor: "#f9fafb",
                            color: "#374151",
                            boxSizing: "border-box",
                          }}
                        />
                      </Box>
                      <IconButton
                        onClick={() => {
                          if (fileRef.current) {
                            fileRef.current.click();
                          }
                        }}
                        sx={{ flexShrink: 0 }}
                      >
                        <FileUploadOutlinedIcon />
                        <input
                          type="file"
                          id="file"
                          ref={fileRef}
                          onChange={() => {
                            if (uploadUrl === "") {
                              getUplaodUrl();
                            }
                          }}
                          accept="image/png, image/jpeg, image/jpg, application/pdf"
                          style={{ display: "none" }}
                        />
                      </IconButton>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                      mb: 2,
                    }}
                  >
                    <Box
                      onClick={() => handleAddInvoice(invoice.productId, invoice.invoiceType)}
                      sx={{
                        px: 3,
                        py: 1,
                        backgroundColor: isUploading ? "#9ca3af" : "#3b82f6",
                        color: "white",
                        borderRadius: "8px",
                        fontSize: 14,
                        fontWeight: 500,
                        cursor: isUploading ? "not-allowed" : "pointer",
                        pointerEvents: isUploading ? "none" : "auto",
                      }}
                    >
                      ADD
                    </Box>
                  </Box>
                </>
              )}

              {/* Invoice Totals - Desktop */}
              <Box sx={{ display: { xs: "none", md: "block" }, mt: 4 }}>
                <Box
                  sx={{
                    textAlign: "right",
                    marginRight: "20px",
                    maxWidth: "300px",
                    marginLeft: "auto",
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Box sx={{ fontWeight: 600 }}>Invoice Total:</Box>
                    <Box>${invoice.total.invoiceTotal || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Box sx={{ fontWeight: 600 }}>Estimate Total:</Box>
                    <Box>${invoice.total.estimateTotal || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Box sx={{ fontWeight: 600 }}>Payment Due:</Box>
                    <Box>${invoice.total.paymentDue || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ fontWeight: 600 }}>Refund Due:</Box>
                    <Box>${invoice.total.refundDue || 0}</Box>
                  </Box>
                </Box>
              </Box>

              {/* Mobile Card View */}
              <Box sx={{ display: { xs: "block", md: "none" } }}>
                {invoice?.Items?.map((item, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      padding: 2,
                      mb: 1.5,
                    }}
                  >
                    {editingItem && editingItem.invoiceIdx === index && editingItem.itemIdx === idx ? (
                      <>
                        {/* Edit Mode */}
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr", gap: 2, mb: 2 }}>
                          <Box>
                            <Typography sx={{ mb: 0.75, fontSize: 14, fontWeight: 500, color: "#374151" }}>Contractor/Supplier</Typography>
                            <input
                              type="text"
                              value={editItemData.name || ""}
                              onChange={e => setEditItemData({ ...editItemData, name: e.target.value })}
                              style={{
                                padding: "12px 14px",
                                borderRadius: "6px",
                                border: "1px solid #d1d5db",
                                fontSize: "14px",
                                width: "100%",
                                backgroundColor: "#f9fafb",
                                color: "#374151",
                                boxSizing: "border-box",
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography sx={{ mb: 0.75, fontSize: 14, fontWeight: 500, color: "#374151" }}>Identifier</Typography>
                            <input
                              type="text"
                              value={editItemData.identifier || ""}
                              onChange={e => setEditItemData({ ...editItemData, identifier: e.target.value })}
                              style={{
                                padding: "12px 14px",
                                borderRadius: "6px",
                                border: "1px solid #d1d5db",
                                fontSize: "14px",
                                width: "100%",
                                backgroundColor: "#f9fafb",
                                color: "#374151",
                                boxSizing: "border-box",
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography sx={{ mb: 0.75, fontSize: 14, fontWeight: 500, color: "#374151" }}>Date</Typography>
                            <input
                              type="date"
                              value={editItemData.date}
                              onChange={e => setEditItemData({ ...editItemData, date: e.target.value })}
                              style={{
                                padding: "12px 14px",
                                borderRadius: "6px",
                                border: "1px solid #d1d5db",
                                fontSize: "14px",
                                width: "100%",
                                backgroundColor: "#f9fafb",
                                color: "#374151",
                                boxSizing: "border-box",
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography sx={{ mb: 0.75, fontSize: 14, fontWeight: 500, color: "#374151" }}>Total</Typography>
                            <input
                              type="number"
                              value={editItemData.amount || 0}
                              onChange={e => setEditItemData({ ...editItemData, amount: e.target.value })}
                              style={{
                                padding: "12px 14px",
                                borderRadius: "6px",
                                border: "1px solid #d1d5db",
                                fontSize: "14px",
                                width: "100%",
                                backgroundColor: "#f9fafb",
                                color: "#374151",
                                boxSizing: "border-box",
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography sx={{ mb: 0.75, fontSize: 14, fontWeight: 500, color: "#374151" }}>Description</Typography>
                            <textarea
                              value={editItemData.description || ""}
                              onChange={e => setEditItemData({ ...editItemData, description: e.target.value })}
                              rows={2}
                              style={{
                                padding: "12px 14px",
                                borderRadius: "6px",
                                border: "1px solid #d1d5db",
                                fontSize: "14px",
                                width: "100%",
                                backgroundColor: "#f9fafb",
                                color: "#374151",
                                boxSizing: "border-box",
                                resize: "vertical",
                                fontFamily: "inherit",
                              }}
                            />
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                          {item?.url && item.url.length > 0 && (
                            <Box
                              onClick={() => window.open(item.url)}
                              sx={{
                                px: 2,
                                py: 0.75,
                                backgroundColor: "#4b87ed",
                                color: "white",
                                borderRadius: "6px",
                                fontSize: 13,
                                fontWeight: 500,
                                cursor: "pointer",
                              }}
                            >
                              View
                            </Box>
                          )}
                          <Box
                            onClick={async () => {
                              let date = editItemData.date;
                              if (date && date.includes('-')) {
                                const [year, month, day] = date.split('-');
                                date = `${day}/${month}/${year}`;
                              }
                              const input = {
                                ...editItemData,
                                invoiceId: editItemData.id,
                                amount: Number(editItemData.amount),
                                date,
                              };
                              delete input.id;
                              await updateInvoice({ variables: { input } });
                              setEditingItem(null);
                              if (refetchInvoices) refetchInvoices();
                            }}
                            sx={{
                              px: 2,
                              py: 0.75,
                              backgroundColor: "#22c55e",
                              color: "white",
                              borderRadius: "6px",
                              fontSize: 13,
                              fontWeight: 500,
                              cursor: "pointer",
                            }}
                          >
                            Save
                          </Box>
                          <Box
                            onClick={() => setEditingItem(null)}
                            sx={{
                              px: 2,
                              py: 0.75,
                              backgroundColor: "#ef4444",
                              color: "white",
                              borderRadius: "6px",
                              fontSize: 13,
                              fontWeight: 500,
                              cursor: "pointer",
                            }}
                          >
                            Cancel
                          </Box>
                        </Box>
                      </>
                    ) : (
                      <>
                        {/* View Mode */}
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5, mb: 1.5 }}>
                          <Box>
                            <Box sx={{ fontSize: 12, color: "#6b7280", mb: 0.5 }}>Contractor/Supplier</Box>
                            <Box sx={{ fontSize: 14, fontWeight: 500, color: "#374151" }}>{item.name}</Box>
                          </Box>
                          <Box>
                            <Box sx={{ fontSize: 12, color: "#6b7280", mb: 0.5 }}>Identifier</Box>
                            <Box sx={{ fontSize: 14, fontWeight: 500, color: "#374151" }}>{item.identifier}</Box>
                          </Box>
                          <Box>
                            <Box sx={{ fontSize: 12, color: "#6b7280", mb: 0.5 }}>Date</Box>
                            <Box sx={{ fontSize: 14, fontWeight: 500, color: "#374151" }}>{item.date}</Box>
                          </Box>
                          <Box>
                            <Box sx={{ fontSize: 12, color: "#6b7280", mb: 0.5 }}>Total</Box>
                            <Box sx={{ fontSize: 14, fontWeight: 600, color: "#22c55e" }}>${item.amount.toFixed(2)}</Box>
                          </Box>
                        </Box>
                        <Box sx={{ mb: 1.5 }}>
                          <Box sx={{ fontSize: 12, color: "#6b7280", mb: 0.5 }}>Description</Box>
                          <Box sx={{ fontSize: 14, color: "#374151" }}>{item.description}</Box>
                        </Box>
                        <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                          {item?.url && item.url.length > 0 && (
                            <Box
                              onClick={() => window.open(item.url)}
                              sx={{
                                px: 2,
                                py: 0.75,
                                backgroundColor: "#4b87ed",
                                color: "white",
                                borderRadius: "6px",
                                fontSize: 13,
                                fontWeight: 500,
                                cursor: "pointer",
                              }}
                            >
                              View
                            </Box>
                          )}
                          {permissions && (
                            <Box
                              onClick={() => {
                                setEditingItem({ invoiceIdx: index, itemIdx: idx });
                                let formattedDate = "";
                                if (item.date) {
                                  const [month, day, year] = item.date.split("/");
                                  formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
                                }
                                setEditItemData({ ...item, date: formattedDate });
                              }}
                              sx={{
                                px: 2,
                                py: 0.75,
                                backgroundColor: "#3b82f6",
                                color: "white",
                                borderRadius: "6px",
                                fontSize: 13,
                                fontWeight: 500,
                                cursor: "pointer",
                              }}
                            >
                              Edit
                            </Box>
                          )}
                        </Box>
                      </>
                    )}
                  </Box>
                ))}

                {/* Mobile Totals */}
                <Box sx={{ mt: 3, p: 2, backgroundColor: "#f9fafb", borderRadius: "8px" }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}>
                    <Box sx={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>Invoice Total:</Box>
                    <Box sx={{ fontSize: 14, fontWeight: 500 }}>${invoice.total.invoiceTotal || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}>
                    <Box sx={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>Estimate Total:</Box>
                    <Box sx={{ fontSize: 14, fontWeight: 500 }}>${invoice.total.estimateTotal || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}>
                    <Box sx={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>Payment Due:</Box>
                    <Box sx={{ fontSize: 14, fontWeight: 500, color: "#22c55e" }}>${invoice.total.paymentDue || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>Refund Due:</Box>
                    <Box sx={{ fontSize: 14, fontWeight: 500, color: "#ef4444" }}>${invoice.total.refundDue || 0}</Box>
                  </Box>
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </>
    );
  };

  const AddOnDetails = () => {
    return (
      <>
        {addOns?.map((addOn, index) => (
          <Accordion
            key={index}
            sx={{
              border: "1px solid #e5e7eb",
              borderRadius: "8px !important",
              boxShadow: "none",
              mb: 1.5,
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                "&:hover": { backgroundColor: "#f9fafb" },
              }}
            >
              <Box sx={{ fontSize: { xs: 15, sm: 17 }, fontWeight: 600, color: "#1f2937" }}>
                {addOn.name.replace("-", " - ")}
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ px: { xs: 1, sm: 2 } }}>
              {/* Desktop Table View */}
              <Box sx={{ display: { xs: "none", md: "block" }, width: "100%", overflowX: "auto" }}>
                <table style={{ width: "100%", minWidth: "600px" }}>
                  <thead>
                    <tr
                      className="text-left"
                      style={{ borderBottom: "1px solid black" }}
                    >
                      <th
                        className="font-semibold pb-2"
                        style={{ width: "20%" }}
                      >
                        Contractor/ Supplier
                      </th>
                      <th
                        className="font-semibold pb-2"
                        style={{ width: "20%" }}
                      >
                        Description
                      </th>
                      <th
                        className="font-semibold pb-2"
                        style={{ width: "20%" }}
                      >
                        Identifier
                      </th>
                      <th
                        className="font-semibold pb-2"
                        style={{ width: "20%" }}
                      >
                        Date
                      </th>
                      <th
                        className="font-semibold pb-2"
                        style={{ width: "20%" }}
                      >
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {addOn?.Items?.map((item, idx) => (
                        <tr key={idx}>
                          {editingItem && editingItem.invoiceIdx === index && editingItem.itemIdx === idx ? (
                            <>
                              <td>
                                <TextField
                                  size="small"
                                  value={editItemData.name || ""}
                                  onChange={e => setEditItemData({ ...editItemData, name: e.target.value })}
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  value={editItemData.description || ""}
                                  onChange={e => setEditItemData({ ...editItemData, description: e.target.value })}
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  value={editItemData.identifier || ""}
                                  onChange={e => setEditItemData({ ...editItemData, identifier: e.target.value })}
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  type="date"
                                  value={editItemData.date ? editItemData.date.split('T')[0] : ""}
                                  onChange={e => setEditItemData({ ...editItemData, date: e.target.value })}
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  type="number"
                                  value={editItemData.amount || 0}
                                  onChange={e => setEditItemData({ ...editItemData, amount: e.target.value })}
                                />
                              </td>
                              <td>
                                <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                  <IconButton
                                    onClick={() =>
                                      item?.url.length > 0 && window.open(item?.url)
                                    }
                                  >
                                    <OpenInNewRoundedIcon />
                                  </IconButton>
                                  <IconButton color="primary" onClick={() => {/* Save logic to be added */}}>
                                    <span className="material-icons">check</span>
                                  </IconButton>
                                  <IconButton color="secondary" onClick={() => setEditingItem(null)}>
                                    <span className="material-icons">close</span>
                                  </IconButton>
                                </div>
                              </td>
                            </>
                          ) : (
                            <>
                              <td>{item.name}</td>
                              <td>{item.description}</td>
                              <td>{item.identifier}</td>
                              <td>{new Date(item.date).toLocaleDateString()}</td>
                              <td>${item.amount.toFixed(2)}</td>
                              <td>
                                <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                  <IconButton
                                    onClick={() =>
                                      item?.url.length > 0 && window.open(item?.url)
                                    }
                                  >
                                    <OpenInNewRoundedIcon />
                                  </IconButton>
                                  {permissions && (
                                    <IconButton onClick={() => {
                                      setEditingItem({ invoiceIdx: index, itemIdx: idx });
                                      setEditItemData({ ...item });
                                    }}>
                                      <span className="material-icons">edit</span>
                                    </IconButton>
                                  )}
                                </div>
                              </td>
                            </>
                          )}
                        </tr>
                    ))}
                  </tbody>
                </table>
              </Box>

              {/* Add New AddOn Item Inputs - Visible on all screens */}
              {permissions && (
                <>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(5, 1fr)" },
                      gap: 1.5,
                      width: "100%",
                      mb: 1,
                      mt: 2,
                    }}
                  >
                    <TextField
                      size="small"
                      label="Contractor Name"
                      variant="outlined"
                      name="name"
                      value={newInvoice.name}
                      onChange={handleInputChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Description"
                      variant="outlined"
                      name="description"
                      value={newInvoice.description}
                      onChange={handleInputChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Identifier"
                      variant="outlined"
                      name="identifier"
                      value={newInvoice.identifier}
                      onChange={handleInputChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Date"
                      variant="outlined"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      name="date"
                      value={newInvoice.date}
                      onChange={handleInputChange}
                      fullWidth
                    />
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <TextField
                        size="small"
                        label="Amount"
                        variant="outlined"
                        type="number"
                        name="amount"
                        value={newInvoice.amount}
                        onChange={handleInputChange}
                        fullWidth
                      />
                      <IconButton
                        onClick={() => {
                          if (fileRef.current) {
                            fileRef.current.click();
                          }
                        }}
                        sx={{ flexShrink: 0 }}
                      >
                        <FileUploadOutlinedIcon />
                        <input
                          type="file"
                          id="file"
                          ref={fileRef}
                          onChange={() => {
                            if (uploadUrl === "") {
                              getUplaodUrl();
                            }
                          }}
                          accept="image/png, image/jpeg, image/jpg, application/pdf"
                          style={{ display: "none" }}
                        />
                      </IconButton>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                      mb: 2,
                    }}
                  >
                    <Box
                      onClick={() => handleAddInvoice(1, "AddOns")}
                      sx={{
                        px: 3,
                        py: 1,
                        backgroundColor: isUploading ? "#9ca3af" : "#3b82f6",
                        color: "white",
                        borderRadius: "8px",
                        fontSize: 14,
                        fontWeight: 500,
                        cursor: isUploading ? "not-allowed" : "pointer",
                        pointerEvents: isUploading ? "none" : "auto",
                      }}
                    >
                      ADD
                    </Box>
                  </Box>
                </>
              )}

              {/* AddOn Totals - Desktop */}
              <Box sx={{ display: { xs: "none", md: "block" }, mt: 4 }}>
                <Box
                  sx={{
                    textAlign: "right",
                    marginRight: "20px",
                    maxWidth: "300px",
                    marginLeft: "auto",
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Box sx={{ fontWeight: 600 }}>Add-On Total:</Box>
                    <Box>${addOn.total.invoiceTotal || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Box sx={{ fontWeight: 600 }}>Estimate Total:</Box>
                    <Box>${addOn.total.estimateTotal || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Box sx={{ fontWeight: 600 }}>Payment Due:</Box>
                    <Box>${addOn.total.paymentDue || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ fontWeight: 600 }}>Refund Due:</Box>
                    <Box>${addOn.total.refundDue || 0}</Box>
                  </Box>
                </Box>
              </Box>

              {/* Mobile Card View */}
              <Box sx={{ display: { xs: "block", md: "none" } }}>
                {addOn?.Items?.map((item, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      padding: 2,
                      mb: 1.5,
                    }}
                  >
                    {editingItem && editingItem.invoiceIdx === index && editingItem.itemIdx === idx ? (
                      <>
                        {/* Edit Mode */}
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr", gap: 1.5, mb: 1.5 }}>
                          <TextField
                            size="small"
                            label="Contractor/Supplier"
                            value={editItemData.name || ""}
                            onChange={e => setEditItemData({ ...editItemData, name: e.target.value })}
                            fullWidth
                          />
                          <TextField
                            size="small"
                            label="Identifier"
                            value={editItemData.identifier || ""}
                            onChange={e => setEditItemData({ ...editItemData, identifier: e.target.value })}
                            fullWidth
                          />
                          <TextField
                            size="small"
                            label="Date"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={editItemData.date ? editItemData.date.split('T')[0] : ""}
                            onChange={e => setEditItemData({ ...editItemData, date: e.target.value })}
                            fullWidth
                          />
                          <TextField
                            size="small"
                            label="Total"
                            type="number"
                            value={editItemData.amount || 0}
                            onChange={e => setEditItemData({ ...editItemData, amount: e.target.value })}
                            fullWidth
                          />
                          <TextField
                            size="small"
                            label="Description"
                            value={editItemData.description || ""}
                            onChange={e => setEditItemData({ ...editItemData, description: e.target.value })}
                            fullWidth
                            multiline
                            rows={2}
                          />
                        </Box>
                        <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                          {item?.url && item.url.length > 0 && (
                            <Box
                              onClick={() => window.open(item.url)}
                              sx={{
                                px: 2,
                                py: 0.75,
                                backgroundColor: "#4b87ed",
                                color: "white",
                                borderRadius: "6px",
                                fontSize: 13,
                                fontWeight: 500,
                                cursor: "pointer",
                              }}
                            >
                              View
                            </Box>
                          )}
                          <Box
                            onClick={() => {
                              // Save logic placeholder
                              setEditingItem(null);
                            }}
                            sx={{
                              px: 2,
                              py: 0.75,
                              backgroundColor: "#22c55e",
                              color: "white",
                              borderRadius: "6px",
                              fontSize: 13,
                              fontWeight: 500,
                              cursor: "pointer",
                            }}
                          >
                            Save
                          </Box>
                          <Box
                            onClick={() => setEditingItem(null)}
                            sx={{
                              px: 2,
                              py: 0.75,
                              backgroundColor: "#ef4444",
                              color: "white",
                              borderRadius: "6px",
                              fontSize: 13,
                              fontWeight: 500,
                              cursor: "pointer",
                            }}
                          >
                            Cancel
                          </Box>
                        </Box>
                      </>
                    ) : (
                      <>
                        {/* View Mode */}
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5, mb: 1.5 }}>
                          <Box>
                            <Box sx={{ fontSize: 12, color: "#6b7280", mb: 0.5 }}>Contractor/Supplier</Box>
                            <Box sx={{ fontSize: 14, fontWeight: 500, color: "#374151" }}>{item.name}</Box>
                          </Box>
                          <Box>
                            <Box sx={{ fontSize: 12, color: "#6b7280", mb: 0.5 }}>Identifier</Box>
                            <Box sx={{ fontSize: 14, fontWeight: 500, color: "#374151" }}>{item.identifier}</Box>
                          </Box>
                          <Box>
                            <Box sx={{ fontSize: 12, color: "#6b7280", mb: 0.5 }}>Date</Box>
                            <Box sx={{ fontSize: 14, fontWeight: 500, color: "#374151" }}>{new Date(item.date).toLocaleDateString()}</Box>
                          </Box>
                          <Box>
                            <Box sx={{ fontSize: 12, color: "#6b7280", mb: 0.5 }}>Total</Box>
                            <Box sx={{ fontSize: 14, fontWeight: 600, color: "#22c55e" }}>${item.amount.toFixed(2)}</Box>
                          </Box>
                        </Box>
                        <Box sx={{ mb: 1.5 }}>
                          <Box sx={{ fontSize: 12, color: "#6b7280", mb: 0.5 }}>Description</Box>
                          <Box sx={{ fontSize: 14, color: "#374151" }}>{item.description}</Box>
                        </Box>
                        <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                          {item?.url && item.url.length > 0 && (
                            <Box
                              onClick={() => window.open(item.url)}
                              sx={{
                                px: 2,
                                py: 0.75,
                                backgroundColor: "#4b87ed",
                                color: "white",
                                borderRadius: "6px",
                                fontSize: 13,
                                fontWeight: 500,
                                cursor: "pointer",
                              }}
                            >
                              View
                            </Box>
                          )}
                          {permissions && (
                            <Box
                              onClick={() => {
                                setEditingItem({ invoiceIdx: index, itemIdx: idx });
                                setEditItemData({ ...item });
                              }}
                              sx={{
                                px: 2,
                                py: 0.75,
                                backgroundColor: "#3b82f6",
                                color: "white",
                                borderRadius: "6px",
                                fontSize: 13,
                                fontWeight: 500,
                                cursor: "pointer",
                              }}
                            >
                              Edit
                            </Box>
                          )}
                        </Box>
                      </>
                    )}
                  </Box>
                ))}

                {/* Mobile Totals */}
                <Box sx={{ mt: 3, p: 2, backgroundColor: "#f9fafb", borderRadius: "8px" }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}>
                    <Box sx={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>Add-On Total:</Box>
                    <Box sx={{ fontSize: 14, fontWeight: 500 }}>${addOn.total.invoiceTotal || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}>
                    <Box sx={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>Estimate Total:</Box>
                    <Box sx={{ fontSize: 14, fontWeight: 500 }}>${addOn.total.estimateTotal || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}>
                    <Box sx={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>Payment Due:</Box>
                    <Box sx={{ fontSize: 14, fontWeight: 500, color: "#22c55e" }}>${addOn.total.paymentDue || 0}</Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>Refund Due:</Box>
                    <Box sx={{ fontSize: 14, fontWeight: 500, color: "#ef4444" }}>${addOn.total.refundDue || 0}</Box>
                  </Box>
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </>
    );
  };

  return (
    <>
      {InvoiceDetails()}
      {AddOnDetails()}
      <Spacer size={1} direction="col" />
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 1.5,
          mt: 2,
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <span style={{ fontSize: '14px', color: '#4b5563', fontWeight: 500 }}>Brand Styling:</span>
          <select
            value={selectedBrand}
            onChange={(e) => setSelectedBrand(e.target.value)}
            style={{
              padding: '6px 12px',
              borderRadius: '8px',
              border: '1px solid #d1d5db',
              backgroundColor: '#fff',
              fontSize: '14px',
              outline: 'none',
              cursor: 'pointer'
            }}
          >
            <option value="glas">Glas</option>
            <option value="waybe">Waybe</option>
          </select>
        </Box>
        <Box
          onClick={handleGenerateFinalInvoice}
          sx={{
            px: { xs: 2, sm: 2.5 },
            py: 1,
            backgroundColor: isPreviewLoading || previewLoading ? "#9ca3af" : "#3b82f6",
            color: "white",
            borderRadius: "8px",
            fontSize: { xs: 13, sm: 14 },
            fontWeight: 500,
            cursor: isPreviewLoading || previewLoading ? "not-allowed" : "pointer",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            "&:hover": isPreviewLoading || previewLoading ? {} : { backgroundColor: "#2563eb" },
            pointerEvents: isPreviewLoading || previewLoading ? "none" : "auto",
          }}
        >
          {isPreviewLoading ? 'Generating...' : 'Generate Final Invoice'}
        </Box>
        <Box
          onClick={handlePreviewInvoice}
          sx={{
            px: { xs: 2, sm: 2.5 },
            py: 1,
            backgroundColor: "white",
            color: "#3b82f6",
            border: "1px solid #3b82f6",
            borderRadius: "8px",
            fontSize: { xs: 13, sm: 14 },
            fontWeight: 500,
            cursor: "pointer",
            "&:hover": { backgroundColor: "#eff6ff" },
          }}
        >
          Preview Invoice
        </Box>
        <Box
          onClick={handleOpenSendEmail}
          sx={{
            px: { xs: 2, sm: 2.5 },
            py: 1,
            backgroundColor: sending ? "#9ca3af" : "#10b981",
            color: "white",
            borderRadius: "8px",
            fontSize: { xs: 13, sm: 14 },
            fontWeight: 500,
            cursor: sending ? "not-allowed" : "pointer",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            "&:hover": sending ? {} : { backgroundColor: "#059669" },
            pointerEvents: sending ? "none" : "auto",
          }}
        >
          Send Email to Client
        </Box>
      </Box>

        {/* Send Email Dialog */}
        <CustomAlert
          open={sendEmailOpen}
          onClose={() => setSendEmailOpen(false)}
          // @ts-ignore: CustomAlert title prop accepts ReactNode
          title={
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
              <Box sx={{ flex: 1, textAlign: 'center', fontWeight: 600, fontSize: 22 }}>Send Invoice Email</Box>
              <IconButton
                aria-label="close"
                onClick={() => setSendEmailOpen(false)}
                sx={{ position: 'absolute', right: 0, top: -15, color: 'grey.600' }}
                size="large"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          }
          width={500}
          Content={
            <Box sx={{ minWidth: 420, maxWidth: 520, display: 'flex', flexDirection: 'column', gap: 3, p: 2 }}>
              <TextField
                label="Recipient Email"
                type="email"
                value={emailInput}
                onChange={e => setEmailInput(e.target.value)}
                placeholder="Enter client email"
                fullWidth
                size="medium"
                disabled={sending}
                autoFocus
              />
              <TextField
                label="Custom Message"
                value={messageInput}
                onChange={e => setMessageInput(e.target.value)}
                placeholder="Write a message to include with the invoice (optional)"
                fullWidth
                size="small"
                multiline
                minRows={8}
                disabled={sending}
              />
            </Box>
          }
          onConfirm={
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 2, mt: 1 }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setSendEmailOpen(false)}
                disabled={sending}
                sx={{ minWidth: 60, fontWeight: 500, fontSize: 12, py: .8 }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSendEmail}
                disabled={sending}
                sx={{ minWidth: 60, fontWeight: 600, fontSize: 12, py: .8 }}
              >
                {sending ? "Sending..." : "Send Email"}
              </Button>
            </Box>
          }
        />
    </>
  );
};
